"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class SequentialTaskExecutor {
    constructor(logger) {
        this._queuedTaskSubject = null;
        this._isCompleted = false;
        this._logger = logger;
    }
    get isCompleted() { return this._isCompleted; }
    init(errorHandler) {
        if (this._queuedTaskSubject) {
            this.terminate();
        }
        this._queuedTaskSubject = new rxjs_1.Subject();
        this._queuedTaskSubject
            .pipe(operators_1.concatMap(f => rxjs_1.defer(() => f())))
            .subscribe({
            next: (item) => { },
            error: errorHandler ? (error) => errorHandler(error, "") : (e) => this._logger.error(`${this._logger.name}.${SequentialTaskExecutor.name} error, stopped. reason=`, e),
            complete: () => this._isCompleted = true
        });
        this._errorHandler = errorHandler;
        this._isCompleted = false;
    }
    async initAsync(errorHandler) {
        this.init(errorHandler);
    }
    terminate() {
        if (!this._queuedTaskSubject)
            return;
        this._queuedTaskSubject.unsubscribe();
        this._queuedTaskSubject = null;
    }
    async terminateAsync() {
        this.terminate();
    }
    pushTask(task, taskName = "", defaultReturnValue = {}) {
        if (!this._queuedTaskSubject) {
            this._logger.error(`${this._logger.name}.${SequentialTaskExecutor.name} is not initialized.`);
            return Promise.resolve(defaultReturnValue);
        }
        // to check task is added and not waiting to end of task then add next task.
        //if (taskName) this._logger.debug(`${this._logger.name} Adding ${taskName}`);
        const promise = new Promise((resolve, reject) => {
            //if not initialized, resove with default return value immediately
            if (!this._queuedTaskSubject)
                resolve(defaultReturnValue);
            const wrappedOperation = async () => {
                try {
                    if (taskName)
                        this._logger.debug(`${this._logger.name} Begin Handling ${taskName}`);
                    const result = await task();
                    if (taskName)
                        this._logger.debug(`${this._logger.name} End Handling ${taskName}`);
                    resolve(result);
                }
                catch (error) {
                    resolve(defaultReturnValue); //resove immediately to prevent outside waiting.
                    if (this._errorHandler)
                        this._errorHandler(error, taskName);
                }
            };
            if (this._queuedTaskSubject)
                this._queuedTaskSubject.next(wrappedOperation);
        });
        return promise;
    }
    stop() {
        if (!this._queuedTaskSubject)
            return;
        this._queuedTaskSubject.complete();
    }
}
exports.SequentialTaskExecutor = SequentialTaskExecutor;
//# sourceMappingURL=SequentialTaskExecutor.js.map